﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.StringUtils
 * @description
 * # StringUtils
 */

angular.module('ntmApp')
    .run(function () {

        String.prototype.replaceAll = function (target, replacement) {
            return this.split(target).join(replacement);
        };

        if (!String.prototype.format) {
            String.prototype.format = function () {
                var args = arguments;
                return this.replace(/{(\d+)}/g, function (match, number) {
                    return typeof args[number] !== 'undefined' ? args[number] : match;
                });
            };
        }

    });